import { ncbClient } from './ncbClient';

// Hardcoded admin credentials for easy access
const ADMIN_CREDENTIALS = {
  email: 'admin@shophub.com',
  password: 'admin123',
  user: {
    id: 'admin-001',
    email: 'admin@shophub.com',
    username: 'Admin User',
    firstName: 'Admin',
    lastName: 'User',
    role: 'admin'
  }
};

export const authService = {
  async login(email, password) {
    try {
      // Check for hardcoded admin credentials first
      if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
        const token = btoa(JSON.stringify({
          userId: ADMIN_CREDENTIALS.user.id,
          email: ADMIN_CREDENTIALS.user.email,
          role: 'admin'
        }));
        localStorage.setItem('auth-token', token);
        localStorage.setItem('user-data', JSON.stringify(ADMIN_CREDENTIALS.user));
        return ADMIN_CREDENTIALS.user;
      }
      
      // For NoCodeBackend, we'll search for user and validate password
      const response = await ncbClient.searchUsers({ email: email });
      
      if (response.data && response.data.length > 0) {
        const user = response.data[0];
        // In a real app, you'd hash and compare passwords
        if (user.password === password) {
          // Simplified for demo
          const token = btoa(JSON.stringify({
            userId: user.user_id,
            email: user.email,
            role: 'user'
          }));
          localStorage.setItem('auth-token', token);
          localStorage.setItem('user-data', JSON.stringify({
            id: user.user_id,
            email: user.email,
            username: user.username,
            role: 'user'
          }));
          return {
            id: user.user_id,
            email: user.email,
            username: user.username,
            role: 'user'
          };
        }
      }
      
      throw new Error('Invalid credentials');
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  },

  async register(userData) {
    try {
      const response = await ncbClient.createUser({
        username: userData.firstName + ' ' + userData.lastName,
        email: userData.email,
        password: userData.password,
        created_at: new Date().toISOString()
      });
      
      const user = {
        id: response.id,
        email: userData.email,
        username: userData.firstName + ' ' + userData.lastName,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
        role: 'user'
      };
      
      const token = btoa(JSON.stringify({
        userId: user.id,
        email: user.email,
        role: 'user'
      }));
      localStorage.setItem('auth-token', token);
      localStorage.setItem('user-data', JSON.stringify(user));
      
      return user;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Registration failed');
    }
  },

  async logout() {
    try {
      // NoCodeBackend doesn't have a logout endpoint, just clear local storage
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('auth-token');
      localStorage.removeItem('user-data');
    }
  },

  async getCurrentUser() {
    try {
      // Check for admin token first
      const token = localStorage.getItem('auth-token');
      if (!token) return null;
      
      const decoded = JSON.parse(atob(token));
      
      // If admin, return admin user
      if (decoded.role === 'admin') {
        const userData = localStorage.getItem('user-data');
        if (userData) {
          return JSON.parse(userData);
        }
        return ADMIN_CREDENTIALS.user;
      }
      
      // For regular users, fetch from API
      const response = await ncbClient.searchUsers({ user_id: decoded.userId });
      
      if (response.data && response.data.length > 0) {
        const user = response.data[0];
        return {
          id: user.user_id,
          email: user.email,
          username: user.username,
          role: 'user'
        };
      }
      
      return null;
    } catch (error) {
      throw new Error('Failed to get current user');
    }
  },
};